import Vue from "vue";
//import App from "./App.vue"
import store from "./store";
//import router from "./router/index"

import "@/assets/tailwind.css";

import Item from "./components/item/Item.vue";
import Cart from "./components/cart/Cart.vue";
import "./util/eventListenerItemClick.js";
import i18n from "./locales/index";

import FunctionControlFittest from "./components/functioncontrol/FunctionControlFittest.vue";
import FunctionControlDelivery from "./components/functioncontrol/FunctionControlDelivery.vue";
import FunctionControlMaintenance from "./components/functioncontrol/FunctionControlMaintenance.vue";
import FunctionControlReferralForm from "./components/functioncontrol/FunctionControlReferralForm.vue";

import OrderMessagesForm from "./components/order/OrderMessagesForm.vue";

import Footer from "./components/footer/Footer.vue";

import GlobalSearchBar from "@/components/searchbar/GlobalSearchBar";

import Register from "./components/register/Register.vue";
import RegisterConfirm from "./components/register-confirm/RegisterConfirm.vue";

import PasswordReset from "./components/authentication/PasswordReset.vue";

import {CollapsePlugin} from "bootstrap-vue";

import Toasted from "vue-toasted";
import AccountActiveProducts from "@/components/account/AccountProductsActive.vue";
import HistoricalProducts from "@/components/account/AccountProductsClosed.vue";
import AccountServices from "@/components/account/AccountServices";

import Attachments from "@/components/attachments/Attachments";
import PersonReports from "@/components/person-reports/PersonReports";

import LanguageSwitcher from "@/components/language-switcher/LanguageSwitcher";
import ConfigurePassword from "@/components/account-setup/ConfigurePassword";

import ItemModalOnLoad from "@/components/item/ItemModalOnLoad";
import PageConversation from "@/views/PageConversation.vue";

Vue.use(Toasted, {
  position: "top-center",
  duration: 5000,
  fitToScreen: true,
});
Vue.use(CollapsePlugin);

Vue.config.productionTip = false;

const getAllAttributes = (el) =>
  el.getAttributeNames().reduce(
    (obj, name) => ({
      ...obj,
      [name]: el.getAttribute(name),
    }),
    {},
  );

// DEV
if (document.getElementById("register")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(Register),
  }).$mount("#register");
}

// DEV
if (document.getElementById("register-confirm")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(RegisterConfirm),
  }).$mount("#register-confirm");
}

if (document.getElementById("footer")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(Footer),
  }).$mount("#footer");
}

if (document.getElementById("passwordReset")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(PasswordReset),
  }).$mount("#passwordReset");
}

if (document.getElementById("configure-password")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(ConfigurePassword),
  }).$mount("#configure-password");
}

if (document.getElementById("fittest")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(FunctionControlFittest),
  }).$mount("#fittest");
}

// Function control Delivery
if (document.getElementById("functioncontrol-delivery")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(FunctionControlDelivery),
  }).$mount("#functioncontrol-delivery");
}

// Function control Maintenance
if (document.getElementById("functioncontrol-maintenance")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(FunctionControlMaintenance),
  }).$mount("#functioncontrol-maintenance");
}

// Item modal on load
if (document.getElementById("item-modal-on-load")) {
  console.log("item-modal-on-load");
  new Vue({
    store,
    i18n,
    render: (h) =>
      h(ItemModalOnLoad, {
        props: getAllAttributes(document.getElementById("item-modal-on-load")),
      }),
  }).$mount("#item-modal-on-load");
}

// Function control Maintenance
if (document.getElementById("functioncontrol-referralform")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(FunctionControlReferralForm),
  }).$mount("#functioncontrol-referralform");
}

if (document.getElementById("order-messages-form")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(OrderMessagesForm),
  }).$mount("#order-messages-form");
}

// if (document.getElementById("app")) {
//   // DEV
//   new Vue({
//     store,
//     i18n,
//     router,
//     render: (h) => h(App),
//   }).$mount("#app")
// }

//Conversation (OrderMessages template)
//
// // check if we can find an element with data-vue-template="OrderMessages"
// if (document.querySelector("[data-vue-template]")) {
//   // get the template
//   const templateName = document.querySelector("[data-vue-template]").dataset
//     .vueTemplate;
//   const template = import(`./views/${templateName}.vue`);
//
//   new Vue({
//     store,
//     i18n,
//     render: (h) => h(template),
//   }).$mount("[data-vue-template]");
// }

// CART
if (document.getElementById("cart")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(Cart),
  }).$mount("#cart");
}

// CONVERSATION PAGE
if (document.getElementById("page-conversation")) {
  new Vue({
    store,
    i18n,
    render: (h) => h(PageConversation),
  }).$mount("#page-conversation");
}

// ITEMS
const productElements = document.querySelectorAll(".vue-item");

if (productElements.length > 0) {
  productElements.forEach((element) =>
    new Vue({
      store,
      i18n,
      render: (h) =>
        h(Item, {
          props: getAllAttributes(element),
        }),
    }).$mount(element),
  );
}

const personReportElement = document.getElementById("vue-person-reports");

if (personReportElement) {
  new Vue({
    store,
    i18n,
    render: (h) => h(PersonReports),
  }).$mount(personReportElement);
}

// ATTACHMENTS
const attachmentElements = document.querySelectorAll(".vue-attachments");

if (attachmentElements.length > 0) {
  attachmentElements.forEach((element) =>
    new Vue({
      store,
      i18n,
      render: (h) =>
        h(Attachments, {
          props: getAllAttributes(element),
        }),
    }).$mount(element),
  );
}

// ACCOUNT PAGE PRODUCTS
const productsElements = document.querySelectorAll(".vue-products");

if (productsElements.length > 0) {
  productsElements.forEach((element) =>
    new Vue({
      store,
      i18n,
      render: (h) =>
        h(AccountActiveProducts, {
          props: getAllAttributes(element),
        }),
    }).$mount(element),
  );
}

// ACCOUNT PAGE HISTORICAL PRODUCTS
const historicalProductsElements = document.querySelectorAll(
  ".vue-historical-products",
);

if (historicalProductsElements.length > 0) {
  historicalProductsElements.forEach((element) =>
    new Vue({
      store,
      i18n,
      render: (h) =>
        h(HistoricalProducts, {
          props: getAllAttributes(element),
        }),
    }).$mount(element),
  );
}
// GLOBAL SEARCH BAR
const globalSearchBarElements = document.querySelectorAll(".global-search-bar");

if (globalSearchBarElements.length > 0) {
  globalSearchBarElements.forEach((element) =>
    new Vue({
      store,
      i18n,
      render: (h) =>
        h(GlobalSearchBar, {
          props: getAllAttributes(element),
        }),
    }).$mount(element),
  );
}

const globalLanguageSwitcherElements =
  document.querySelectorAll(".language-switcher");
if (globalLanguageSwitcherElements.length > 0) {
  globalLanguageSwitcherElements.forEach((element) =>
    new Vue({
      store,
      i18n,
      render: (h) => h(LanguageSwitcher),
    }).$mount(element),
  );
}

// ACCOUNT PAGE HISTORICAL PRODUCTS
const accountServicesElements = document.querySelectorAll(
  ".vue-account-services",
);

if (accountServicesElements.length > 0) {
  accountServicesElements.forEach((element) =>
    new Vue({
      store,
      i18n,
      render: (h) =>
        h(AccountServices, {
          props: getAllAttributes(element),
        }),
    }).$mount(element),
  );
}
